import {
    Action,
    PrimaryResource,
    ProfileConfiguration,
} from "../../../backend/src/common/profile/profile";
import { store } from "../store/store";
import { Offer_type } from "../types/offer.types";

export class OfferAccessRight {
    static offerType(): Offer_type {
        return store.state.offerType;
    }

    static userHasAccess(): boolean {
        return store.getters.isUserHasAccess;
    }

    static isAllowedToMap = {
        isAllowedToDashboard: [
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.BUSINESS_BASIC,
            Offer_type.BUSINESS_SMART,
            Offer_type.BUSINESS_ESSENTIAL,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
        isAllowedToBudget: [
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.BUSINESS_BASIC,
            Offer_type.BUSINESS_SMART,
            Offer_type.BUSINESS_ESSENTIAL,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
        isAllowedToAuditReport: [
            Offer_type.ACCOUNTING_BASIC,
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.ACCOUNTING_STARTER,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
        isAllowedToFixedAsset: [
            Offer_type.ACCOUNTING_BASIC,
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.ACCOUNTING_STARTER,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.BUSINESS_BASIC,
            Offer_type.BUSINESS_SMART,
            Offer_type.BUSINESS_ESSENTIAL,
            Offer_type.TRAINING,
        ],
        isAllowedToDashboardAccounting: [
            Offer_type.ACCOUNTING_BASIC,
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.ACCOUNTING_STARTER,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.BUSINESS_SMART,
            Offer_type.BUSINESS_BASIC,
            Offer_type.BUSINESS_ESSENTIAL,
            Offer_type.TRAINING,
        ],
        isAllowedToOpenPoint: [
            Offer_type.BUSINESS_ESSENTIAL,
            Offer_type.BUSINESS_SMART,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.ACCOUNTING_BASIC,
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.ACCOUNTING_STARTER,
            Offer_type.TRAINING,
        ],
        isAllowedToRestitution: [
            Offer_type.ACCOUNTING_BASIC,
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.BUSINESS_BASIC,
            Offer_type.BUSINESS_SMART,
            Offer_type.BUSINESS_ESSENTIAL,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
        isAllowedToForecastManagement: [
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.BUSINESS_SMART,
            Offer_type.BUSINESS_ESSENTIAL,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
        isAllowedToInvoice: [
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.BUSINESS_BASIC,
            Offer_type.BUSINESS_ESSENTIAL,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
        isAllowedToStock: [
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.BUSINESS_ESSENTIAL,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
        isAllowedToExpenseReport: [
            Offer_type.ACCOUNTING_STARTER,
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.BUSINESS_ESSENTIAL,
            Offer_type.BUSINESS_SMART,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
        isAllowedToTaxDeclaration: [
            Offer_type.ACCOUNTING_BASIC,
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
        isAllowedToAccounting: [
            Offer_type.ACCOUNTING_BASIC,
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.BUSINESS_BASIC,
            Offer_type.BUSINESS_ESSENTIAL,
            Offer_type.BUSINESS_SMART,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
        isAllowedToBundle: [
            Offer_type.ACCOUNTING_BASIC,
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.ACCOUNTING_STARTER,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
        isAllowedToProduction: [
            Offer_type.ACCOUNTING_BASIC,
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
        isAllowedToDeclaration: [
            Offer_type.ACCOUNTING_BASIC,
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
        isAllowedToStatusOfFiles: [
            Offer_type.ACCOUNTING_BASIC,
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.BUSINESS_SMART,
            Offer_type.BUSINESS_ESSENTIAL,
            Offer_type.TRAINING,
        ],
        isAllowedToConnector: [
            Offer_type.ACCOUNTING_ESSENTIAL,
            Offer_type.ACCOUNTING_PREMIUM,
            Offer_type.BUSINESS_SMART,
            Offer_type.BUSINESS_ESSENTIAL,
            Offer_type.BUSINESS_PREMIUM,
            Offer_type.TRAINING,
        ],
    };

    static checkOfferAccessRight(
        permissionName: keyof typeof OfferAccessRight.isAllowedToMap,
        isUserHasAccess: boolean,
        offerType: Offer_type | null = null
    ): boolean {
        if (offerType === null) {
            return (
                this.isAllowedToMap[permissionName]?.includes(this.offerType()) &&
                (isUserHasAccess ? this.userHasAccess() : true)
            );
        } else {
            return (
                this.isAllowedToMap[permissionName]?.includes(offerType) &&
                (isUserHasAccess ? this.userHasAccess() : true)
            );
        }
    }
}

export function checkAccessRights(
    currentUser,
    primary: PrimaryResource | undefined,
    secondary: PrimaryResource | Action | undefined,
    hasOfferAccess: boolean = false,
    permissionName?: keyof typeof OfferAccessRight.isAllowedToMap,
    isUserHasAccess: boolean = false,
    offerType: Offer_type | null = null
): boolean {
    if (!primary || !secondary) {
        return false; // 🔥 Return `false` if `primary` or `secondary` is missing
    }

    const config = currentUser?.profile?.configuration ?? {};

    // Check if `primary` exists in the user's configuration
    const primaryExists = Object.prototype.hasOwnProperty.call(config, primary);

    // Check if `secondary` exists under `primary` in the configuration
    const secondaryExists =
        primaryExists && Object.prototype.hasOwnProperty.call(config[primary], secondary);

    if (!primaryExists || !secondaryExists) {
        return false; // 🔥 Return `false` if `primary` or `secondary` does not exist in the config
    }

    return !!config[primary]?.[secondary] && hasOfferAccess
        ? OfferAccessRight.checkOfferAccessRight(permissionName, isUserHasAccess, offerType)
        : true;
}

/**
 * Compare two profiles configuration, returns an array of errors if authorizations are more permissive, otherwise an empty array
 * @param profileReference The profile configuration set as reference for authorizations
 * @param profileToBeCompared The profile configuration compared, auth should be lesser or equal to profileReference
 * @returns string[] - Array of error messages if more permissive, otherwise empty array
 */
export async function compareConfigurationProfiles(
    vueComponent: any,
    profileReference: ProfileConfiguration,
    profileToBeCompared: ProfileConfiguration,
): Promise<string[]> {
    const keys1 = Object.keys(profileReference);
    const keys2 = Object.keys(profileToBeCompared);
    const errors: string[] = [];

    // Check that the profile being compared contains all the keys of the reference profile
    for (const key of keys1) {
        if (!keys2.includes(key)) {
            errors.push(`Le droit ${key} est manquant dans le profil comparé.`);
            continue; // Continue to check other properties
        }

        const authReference = profileReference[key];
        const authCompared = profileToBeCompared[key];

        // Use compareSubPropertiesAndReturnErrors to gather errors for the sub-properties
        const subErrors = await compareSubPropertiesAndReturnErrors(
            vueComponent,
            authReference,
            authCompared,
            key,
        );

        // If there are errors in sub-properties, append them to the errors list
        if (subErrors.length > 0) {
            errors.push(...subErrors);
        }
    }

    return errors;
}

/**
 * Check each subproperty of configuration profiles and return errors if the compared profile has more permissive authorizations.
 * @param AuthReference The reference authorizations from compareConfigurationProfiles
 * @param AuthCompared The compared authorizations from compareConfigurationProfiles
 * @param tag The tag (key) representing the current property being compared
 * @returns string[] - Array of error messages if more permissive, otherwise empty array
 */
export async function compareSubPropertiesAndReturnErrors(
    vueComponent: any,
    AuthReference: Record<string, boolean>,
    AuthCompared: Record<string, boolean>,
    tag: string,
): Promise<string[]> {
    console.log(AuthReference);
    console.log(AuthCompared);
    const keys1 = Object.keys(AuthReference);
    const keys2 = Object.keys(AuthCompared);
    const errors: string[] = [];

    // Check that both permissions have the same number of sub-properties
    if (keys1.length !== keys2.length) {
        errors.push(`Le droit ${tag} a un nombre différent de sous-propriétés.`);
        return errors;
    }

    for (const key of keys1) {
        if (!keys2.includes(key)) {
            errors.push(
                vueComponent.$t("profile." + tag + ".title") +
                    " manque la sous-propriété " +
                    key +
                    ".",
            );

            continue;
        }

        // Check if the compared authorization is more permissive
        if (AuthReference[key] === false && AuthCompared[key] === true) {
            errors.push(vueComponent.$t("profile." + tag + ".title"));
        }
    }

    return errors;
}
